import { render } from "./RegionCode.vue?vue&type=template&id=e64233e6"
import script from "./RegionCode.vue?vue&type=script&lang=js"
export * from "./RegionCode.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__